import { useQuery } from '@tanstack/react-query';
import { authFetch } from 'shared/api/authFetch';
import { config } from 'shared/config/config';
import { whileVisible } from 'shared/query/attention';

export const SETUP_AGENT_POLL_MS = 3000;
// The coordinator retries for up to an hour; stop polling well before that.
export const SETUP_AGENT_MAX_POLLS = 100;

/**
 * The owner's first-entry state: the Get started plan Otto runs.
 * Polls while the setup is still starting.
 */
export default function useWorkspaceEntry({ organizationId, profileId, enabled }) {
  return useQuery({
    queryKey: ['workspaceEntry', organizationId, profileId],
    enabled: enabled && Boolean(organizationId && profileId),
    queryFn: async ({ signal }) => {
      const response = await authFetch(`${config.API_URL}/api/account/first-entry`, { signal });
      if (!response.ok) throw new Error('Workspace entry could not be loaded.');
      return (await response.json()).first_entry;
    },
    staleTime: 30000,
    // Someone may watch setup start without touching anything.
    refetchInterval: (query) => (
      query.state.data?.setup_pending && query.state.dataUpdateCount < SETUP_AGENT_MAX_POLLS
        ? whileVisible(SETUP_AGENT_POLL_MS)
        : false
    ),
    refetchIntervalInBackground: true,
  });
}
